<script>
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";

export default {
    components: {
        // Multiselect
    },
    name: "ItemCategoryGroup",
    data() {
        return {
            submitted: false,
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "name",
            sortDesc: false,
            fields: [
                {
                    key: "name",
                    sortable: true,
                },
                {
                    key: "actions",
                    thStyle: {width: '90px'}
                },
            ],
            form: {
                id: 0,
                name: "",
                description: "",
            },
            indexSelected: -1,
            tableBusy: false,
        };
    },
    computed: {
        rows() {
            if(this.filter){
                return this.totalRows;
            }
            return this.tableData.length;
        },
    },
    validations: {
        form: {
            name: {required},
        },
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        async getItemCategoryGroup() {
            this.tableBusy = true;
            await this.$store
                .dispatch("itemcategorygroup/GetItemCategoryGroup")
                .then((res) => {
                    res.data.map(item => {
                        item.showPO = false;
                        item.technicalUsers = [];
                        item.technicalLoading = false;
                    })
                    this.tableData = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!","error");
                });
            this.tableBusy = false;
        },
        onReset() {
            this.$v.form.$reset();
            this.form = {
                id: 0,
                name: "",
                description: "",
            };
        },
        addIcg() {
            this.onReset();
            this.modalTitle = "Create New Item Category Group";
            this.$bvModal.show("icg-modal");
        },
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            } else {
                let data = cloneDeep(this.form);
                if (this.form.id > 0) {
                    this.$store
                        .dispatch("itemcategorygroup/UpdateItemCategoryGroup", data)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage,"error");
                            }
                            this.tableData.splice(
                                this.indexSelected,
                                1,
                                data
                            );
                            this.$bvModal.hide("icg-modal");
                            this.showToast("Successfully updated!","success");
                        })
                        .catch((err) => {
                            console.log(err)
                            this.showToast("Something went wrong!","error");
                        });
                } else {
                    this.$store
                        .dispatch("itemcategorygroup/CreateItemCategoryGroup", data)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage,"error");
                            }
                            this.tableData.push(data);
                            this.$bvModal.hide("icg-modal");
                            this.showToast("Successfully created!","success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!","error");
                        });
                }
                this.submitted = false;
            }
        },
        updateItem(props) {
            this.form = cloneDeep(props.item);
            this.indexSelected = this.tableData.indexOf(props.item);
            this.modalTitle = "Update Item Category Group";
            this.$bvModal.show("icg-modal");
        },
        deleteItem(props) {
            var index = this.tableData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("itemcategorygroup/DeleteItemCategoryGroup", props.item.id)
                        .then((res) => {
                            if (res.status == 204) {
                                this.tableData.splice(index, 1);
                                this.showToast("Successfully deleted!","success");
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!","error");
                        });
                }
            });
        },
        getItemCat(props) {
            this.$emit("getItemCat", props.id);
        },
        getItemCategoryMoveData(props) {
            this.moveData = cloneDeep(props);
        },
        onDropZone(event, item){
            // if(this.moveData.targetTemplateDeliveryUnitId == item.id){
            //     this.showToast('Cannot transfer to the same target', 'error');
            //     return;
            // }
            // Swal.fire({
            //     title: 'Are you sure?',
            //     text: "You want to transfer this api to this target?",
            //     icon: 'warning',
            //     showCancelButton: true,
            //     confirmButtonColor: '#3085d6',
            //     cancelButtonColor: '#d33',
            //     confirmButtonText: 'Yes, transfer it!'
            // }).then((result) => {
            //     if (result.isConfirmed) {
            let ids = [];
            this.moveData.itemCategoryAccounts.forEach(item => {
                ids.push(item.accountId);
            });
            let data = {
                id: cloneDeep(this.moveData.id),
                name: cloneDeep(this.moveData.name),
                description: cloneDeep(this.moveData.description),
                type: cloneDeep(this.moveData.type),
                categoryCode: cloneDeep(this.moveData.type),
                itemCategoryGroupId: cloneDeep(item.id),
                accountIds: ids,
            }
            this.$store
            .dispatch("itemcategory/UpdateItemCategory", data)
            .then((res) => {
                this.$emit('successTransfer', this.moveData.id)
                this.showToast("Successfully transferred!", "success");
            })
            .catch(() => {
                this.showToast("Something went wrong!", "error");
            });
                // }
            // })
        },
        getTechnicalUsers(row){
            // if(row.technicalUsers.length == 0){
                row.technicalLoading = true;
                this.$store
                .dispatch("technicalreviewuser/GetCategoryEmployees", {id: row.id, campusId: this.$store.state.data.selectedCampus.id, cycle: this.$store.state.data.cycle})
                .then((res) => {
                    res.data.map(item => {
                        // item.employeeCampus = item.applicationUser.employee.department.deliveryUnit.office.campus.campusName;
                        item.selected = false;
                    })
                    row.technicalUsers = res.data;
                    row.technicalLoading = false;
                })
                .catch(() => {
                    row.technicalLoading = false;
                    this.showToast("Something went wrong! - getting technical users","error");
                });
            // }
        },
        addMoreEmployee(row){
            row.showPO = false;
            this.selectedRow = cloneDeep(row);
            this.$emit('callToOpen', {from: 'Item Category', row});
        },
        saveEmployeeCategories(selected){
            let data = [];
            selected.forEach(item => {
                item.applicationUser.employee = {
                    department: item.department
                }
                data.push({
                    applicationUserId: item.applicationUser.id,
                    itemCategoryGroupId: this.selectedRow.id,
                })
            })
            this.$store
                .dispatch("technicalreviewuser/CreateTechnicalReviewUser", 
                {cycle: this.$store.state.data.cycle, campusId: this.$store.state.data.selectedCampus.id, data: data})
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage,"error");
                    }
                    // let index = 0;
                    // res.data.forEach(item => {
                    //     item.applicationUser = selected[index].applicationUser;
                    //     this.tableData.find(x => x.id == this.selectedRow.id).technicalUsers.push(item);
                    //     index++;
                    // })
                    // this.getTechnicalUsers(this.selectedRow);
                    this.showToast("Successfully added!","success");
                })
            .catch((err) => {
                this.showToast("Something went wrong! - saving technical users","error");
            });
        },
        removeUser(index, row, array){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("technicalreviewuser/DeleteTechnicalReviewUser", row.id)
                        .then((res) => {
                            if (res.status == 204) {
                                array.splice(index, 1);
                                this.showToast("Successfully removed!","success");
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!","error");
                        });
                }
            });
        },
        
        selectAllUser(data){
            data.forEach(item => {
                item.selected = true;
            })
        },
        selectedUser(data){
            let count = 0;
            data.forEach(item => {
                item.selected && count++;
            })
            return count;
        },
        multipleRemoveUser(data){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then(async (result) => {
                if (result.value) {
                    for await (const row of data) {
                        if(row.selected){
                            await this.$store.dispatch("technicalreviewuser/DeleteTechnicalReviewUser", row.id);
                        }
                    }
                    this.showToast("Successfully removed!","success");
                }
            });
        },
    },
    
};
</script>
<template>
    <div>
        <b-modal
            id="icg-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreate"
                class="needs-validation"
                ref="fcForm"
            >
                <div class="mb-3">
                    <label for="name">Name </label>
                    <input
                        autocomplete="off"
                        id="name"
                        type="text"
                        v-model="form.name"
                        placeholder="Enter Category Name..."
                        class="form-control"
                        :class="{
                            'is-invalid':
                                submitted && $v.form.name.$error,
                        }"
                    />
                    <div
                        v-if="submitted && $v.form.name.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.name.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3">
                    <label for="description">Description </label>
                    <input
                        autocomplete="off"
                        id="description"
                        type="text"
                        v-model="form.description"
                        placeholder="Enter Description..."
                        class="form-control"
                        
                    />
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('icg-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <div class="row">
            <div class="col-12">
                <!-- <div
                    class="
                        card
                        border
                    "
                >
                    <div class="card-body"> -->
                        <div
                            class="
                                d-flex
                                row
                                align-items-center
                                mb-2
                                
                            "
                        >
                            <div class="col-md-6 hover-toggle">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title m-0 me-1">Group Category</h4>
                                    <button
                                        type="button"
                                        @click="addIcg()"
                                        class="
                                            btn btn-sm btn-info
                                            d-flex
                                            align-items-center
                                        "
                                    >
                                        <i class="bx bx-plus"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter text-md-end"
                                >
                                    <label
                                        class="d-inline-flex align-items-center mb-0"
                                    >
                                        Search:
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="
                                                form-control form-control-sm
                                                ms-2 me-1
                                            "
                                        ></b-form-input>
                                        <b-form-select
                                            class="form-select form-select-sm w-auto"
                                            v-model="perPage"
                                            size="sm"
                                            :options="pageOptions"
                                        ></b-form-select
                                        >
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                class="datatables"
                                :items="tableData"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                                :busy="tableBusy"
                                @filtered="onFiltered"
                                bordered
                                outlined
                                hover
                                striped
                                show-empty
                            >
                                <template #empty="scope">
                                    <div class="text-center">{{ scope.emptyText }}</div>
                                </template>
                                <template #table-busy>
                                    <div
                                        class="
                                            d-flex
                                            justify-content-center
                                            align-items-center
                                        "
                                    >
                                        <div class="preloader-component me-2">
                                            <div class="status">
                                                <div
                                                    class="
                                                        spinner-chase
                                                        w-20px
                                                        h-20px
                                                    "
                                                >
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>
                                <template #cell(name)="row">
                                    <a href="javascript:void(0)" @click="getItemCat(row.item)" class="text-white hover-underline" 
                                        @drop="onDropZone($event, row.item)"
                                        @dragenter.prevent
                                        @dragover.prevent
                                    >
                                        {{row.value}}
                                    </a>
                                    <a href="javascript:void(0);" class="d-flex align-items-center w-fit" :id="`tu${row.item.id}`" @click="getTechnicalUsers(row.item)"><i class="bx bx-play"></i> View Technical Users</a>
                                    <b-popover
                                        :target="`tu${row.item.id}`"
                                        triggers="click blur"
                                        placement="right"
                                        :show.sync="row.item.showPO"
                                        custom-class="popover-more-spec"
                                    >
                                        <template v-slot:title>
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                "
                                            >
                                                <small
                                                    >Technical Users</small
                                                >
                                                <span
                                                    class="
                                                        bx bx-x
                                                        font-size-14
                                                        cursor-pointer
                                                    "
                                                    @click="
                                                        row.item.showPO = false
                                                    "
                                                ></span>
                                            </div>
                                        </template>
                                        <div v-if="row.item.technicalLoading" class="text-center">
                                            Loading...
                                        </div>
                                        <div v-if="!row.item.technicalLoading && row.item.technicalUsers.length == 0" class="text-center">
                                            No users yet
                                        </div>
                                        <template v-if="!row.item.technicalLoading && row.item.technicalUsers.length > 0">
                                            <div v-for="(x, xIndex) in row.item.technicalUsers" :key="x.id">
                                                <div class="d-flex align-items-center hover-toggle font-size-14">
                                                    <div class="">
                                                        <div class="d-flex mb-1">
                                                            <div class="d-flex align-items-center justify-content-between">
                                                                <div
                                                                
                                                                    class="
                                                                        form-check
                                                                        form-checkbox-outline
                                                                        form-check-success
                                                                        mb-0
                                                                    "
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        :id="`technical-user-${x.id}`"
                                                                        checked="checked"
                                                                        class="
                                                                            form-check-input
                                                                        "
                                                                        v-model="
                                                                            x.selected
                                                                        "
                                                                    />
                                                                    <label :for="`technical-user-${x.id}`" class="mb-0">{{x.applicationUser.completeName}}</label>
                                                                </div>
                                                            </div>
                                                            <div class="hover-content">
                                                                <i class="bx bx-trash text-danger bolder cursor-pointer" @click="removeUser(xIndex, x, row.item.technicalUsers)"></i>
                                                            </div>
                                                        </div>
                                                        <div style="line-height:14px">
                                                            <small><i>{{x.applicationUser.deliveryUnit}}</i></small>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr class="my-2" v-if="(xIndex + 1) != row.item.technicalUsers.length">
                                            </div>
                                        </template>
                                        <div v-if="selectedUser(row.item.technicalUsers)" class="mt-2">
                                            <button type="button" class="btn btn-danger btn-sm btn-block" @click="multipleRemoveUser(row.item.technicalUsers)"><i class="bx bx-x"></i>Remove Selected</button>
                                        </div>
                                        <hr class="mb-2"/>
                                        <div class="d-flex justify-content-between">
                                            <button type="button" class="btn btn-link btn-sm" @click="selectAllUser(row.item.technicalUsers)">Select All</button>
                                            <button
                                                type="button"
                                                class="btn btn-primary me-1 btn-sm btn-success"
                                                @click="
                                                    addMoreEmployee(row.item)
                                                "
                                            >
                                                Add More Employee
                                            </button>
                                        </div>
                                    </b-popover>
                                </template>
                                <template #cell(actions)="row">
                                    <div class="float-end">
                                        <b-dropdown
                                            id="dropdown-dropleft"
                                            right
                                            variant="link"
                                            toggle-class="text-decoration-none"
                                            menu-class="dropdown-menu-end"
                                            no-caret
                                        >
                                            <template #button-content>
                                                <i
                                                    class="fas fa-ellipsis-v"
                                                ></i>
                                            </template>
                                            <b-dropdown-item
                                                @click="updateItem(row)"
                                                variant="secondary"
                                                ><i
                                                    class="
                                                        mdi mdi-update
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Edit</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                                @click="deleteItem(row)"
                                                variant="danger"
                                                ><i
                                                    class="
                                                        mdi mdi-trash-can
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Delete</b-dropdown-item
                                            >
                                        </b-dropdown>
                                    </div>
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div
                                    class="
                                        dataTables_paginate
                                        paging_simple_numbers
                                        float-end
                                    "
                                >
                                    <ul
                                        class="
                                            pagination pagination-rounded
                                            mb-0
                                        "
                                    >
                                        <!-- pagination -->
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="rows"
                                            :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    <!-- </div>
                </div> -->
            </div>
        </div>
    </div>
</template>
